// REACT_APP_API_BASE_URL (e.g. in an untracked .env.local) points a local
// build at a local backend; unset, it is the production API as before.
const API_BASE_URL = "https://fixdesk.api.tecnospice.com/";

export default API_BASE_URL;
